<template>
  <div>
    <el-form
      ref="form"
      :model="bargainForm"
      :rules="bargainRules"
      label-width="130px"
      label-suffix="："
      :class="{ 'detail-form': disabled }"
    >
      <el-form-item label="线下议价" prop="isBargain">
        <span v-if="disabled">
          {{
            whetherDict.translate(bargainForm.isBargain || whetherDict.NO.value)
              .label
          }}
        </span>

        <el-radio-group v-else v-model="bargainForm.isBargain">
          <el-radio
            v-for="item in whetherDict.array"
            :key="item.label"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <template v-if="bargainForm.isBargain === whetherDict.YES.value">
        <el-form-item label="线下议价记录" prop="bargainAttachmentIds">
          <upload
            :file-id-before.sync="bargainForm.bargainAttachmentIds"
            :props-data="{
              uploadMode: 'fileId',
              acceptFileClassify: ['pdf', 'word'],
              limit: 10,
              disabled: disabled
            }"
          />
        </el-form-item>

        <el-form-item label="议价结果" prop="bargainList">
          <el-button
            v-if="!disabled"
            type="primary"
            @click="bargainImportVisible = true"
          >
            导入议价表
          </el-button>

          <jczh-table-content
            v-if="bargainForm.bargainList && bargainForm.bargainList.length"
            class="m-t-10"
            :data="bargainForm.bargainList"
            :option="tableOption"
          />
        </el-form-item>
      </template>
    </el-form>

    <!--模板下载与导入-->
    <template-import-dialog
      v-model="bargainImportVisible"
      title="议价表导入"
      tip-first="下载议价表模板，根据所提供的模板编辑模板表格"
      tip-second="上传表格，点击确认完成议价表导入"
      template-name="议价表模板.xlsx"
      @download="downloadBargainTemplate"
      @upload="uploadBargainTemplate"
      @confirm="confirmImportBargain"
    />
  </div>
</template>

<script>
// 组件
import TemplateImportDialog from '@/components/common/TemplateImportDialog.vue'
import Upload from '@/components/common/Upload/index.vue'

// 工具函数
import { strToThousands } from '@/utils/utils'
import { requiredRule } from '@/utils/form-validate'

// 数据字典
import { whetherDict } from '@/dictionary/project/common'

// api接口
import {
  exportBargainTemplateApi,
  importBargainDataApi
} from '@/api/procure/inquiry'

export default {
  name: 'BargainSheet',

  components: { TemplateImportDialog, Upload },

  props: {
    // sync
    form: {
      type: Object,
      default: () => {
        return {
          isBargain: whetherDict.NO.value,
          bargainAttachmentIds: [],
          bargainList: []
        }
      }
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    isDollar: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 数据字典
      whetherDict,

      bargainRules: {
        isBargain: requiredRule('请选择是否需要线下议价'),
        bargainAttachmentIds: requiredRule('请上传议价记录文件'),
        bargainList: requiredRule('请导入议价结果')
      },
      bargainImportVisible: false,
      bargainListTemp: []
    }
  },

  computed: {
    bargainForm: {
      get() {
        return this.form
      },
      set(val) {
        this.$emit('update:form', val)
      }
    },

    tableOption() {
      return [
        { label: '品目名称', prop: 'materielName' },
        { label: '品目编码', prop: 'materielCode' },
        { label: '数量', prop: 'materielNum' },
        { label: '参数型号', prop: 'materielModel' },
        { label: '品牌/制造商', prop: 'materielBrand' },
        { label: '供应商名称', prop: 'supplierName' },
        {
          label: `议价不含税单价（${this.isDollar ? '美元' : '元'}）`,
          prop: 'bargainPrice',
          filter: value => (value ? strToThousands(value) : '-')
        },
        { label: '税率（%）', prop: 'offerTaxRate' },
        {
          label: `议价不含税总价（${this.isDollar ? '美元' : '元'}）`,
          prop: 'bargainTotalPrice',
          filter: value => (value ? strToThousands(value) : '-')
        },
        {
          label: `议价含税总价（${this.isDollar ? '美元' : '元'}）`,
          prop: 'rateBargainTotalPrice',
          filter: value => (value ? strToThousands(value) : '-')
        }
      ]
    }
  },

  methods: {
    // 校验表单是否填写
    validate() {
      return this.$refs.form.validate()
    },

    // 下载议价模板
    downloadBargainTemplate() {
      exportBargainTemplateApi(this.orderId)
    },

    // 上传议价数据
    uploadBargainTemplate(file) {
      importBargainDataApi(this.orderId, { file })
        .then(res => {
          this.bargainListTemp = res.data || []
        })
        .catch(err => {
          this.$message.error(err?.message || '模板数据导入失败')
        })
    },

    // 确认导入的议价数据
    confirmImportBargain() {
      this.bargainForm.bargainList = this.bargainListTemp
    }
  }
}
</script>

<style scoped></style>
